// extracted by mini-css-extract-plugin
module.exports = {"customer_container":"home_customer_container__1OAE_"};